{
  "actions": "액션",
  "actionsAvailable": "사용 가능한 액션",
  "clearSelection": "선택 항목 지우기",
  "selected": "{count, plural, =0 {선택된 항목 없음} other {#개 선택됨}}",
  "selectedAll": "모두 선택됨"
}
